<template>
    <div>
        <p><strong>Zarizeni:</strong> {{ notification.device_name }}</p>
        <p><strong>Zprava:</strong> {{ notification.message }}</p>

        <div class="d-flex justify-content-end mt-4">
            <button
                v-if="!notification.is_resolved"
                class="btn btn-success btn-sm me-2"
                @click="$emit('resolved')"
                :title="$t('notifications.markAsResolved')"
            >
                <span class="text-white fs-6 fw-bold p-3">Vyresit</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        notification: Object,
    }
}
</script>